module.exports = __webpack_public_path__ + "static/media/whatsapp.ab3a554b.svg";